import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnChanges, OnInit,ViewChild,Output,HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { approvalService } from 'src/app/services/approval.service';
import { trailService } from 'src/app/services/trail.service';
import { Sortingfield } from '../../../enums/sortingfield';
import { LabelType, Options } from "@angular-slider/ngx-slider";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {NgSelectComponent} from '@ng-select/ng-select';
import {MapInfoWindow, MapMarker, GoogleMap} from '@angular/google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
// import data from "../../../../assets/json/vessel_details_8feb_11am.json";

// interface PORTDATA {
//       data:any;
// }

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  
  isChecked=false;
  @Output() dateEvent = new EventEmitter<string>();
  User;
  minValue: number = 0;
  maxValue: number = 100;
  minAgeValue: number = 0;
  maxAgeValue: number = 100;
  maxAgeValueTemp : number;
  minDate : Date;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {  
          case LabelType.Low:  
              return value.toLocaleString();  
          case LabelType.High:  
              return value.toLocaleString();  
          default:  
              return value.toLocaleString();  
      }  
  }  
  };
  optionsAge: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {  
          case LabelType.Low:  
              return value.toLocaleString();  
          case LabelType.High:  
              return value.toLocaleString();  
          default:  
              return value.toLocaleString();  
      }  
  }  
  };
  
  optionsMap: google.maps.MapOptions;
  symbol : google.maps.SymbolPath;
  optionsMap1: any;
  @ViewChild(MapInfoWindow,{ static: false }) infoWindow: MapInfoWindow;
  @ViewChild('googleMap', { static: true }) googleMap: GoogleMap;
  @ViewChild('mapMarker', { static: false }) mapMarker: any[];
  markerCluster?: MarkerClusterer
  markerClustererImagePath =
      'assets/images/circle-layer';
  currentShipIcon = 'assets/images/svg/Vessel-location.svg';
  lineSymbol  = {
    path: "M 0,-1 0,1",
    //path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    strokeOpacity: 100,
    scale: 2,
  };
  recent=[];
  toggle = false;
  toggle1 = true;
  toggle2 = true;
  toggle3 = true;
  toggle4 = true;
  toggle5 = true;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  someHttpdata = false;
  configUrl = "https://supplyforecasting.stoltdev.think360.ai/api/get/ship/lycan_range";
  laycanStart:any;
  laycanEnd:any;
  portData;
  regionType:any = 1;
  weekType:any = 0;
  public getScreenWidth: any;
  sortingFieldName = 'probability';
  sortingFieldType = 'desc';
  sortInprogress = {
    probability: { 'isActive': false, 'isOpen': false, 'value': 'asc' },
    DWT: { 'isActive': false, 'isOpen': false, 'value': 'asc' },
    eta_time: { 'isActive': false, 'isOpen': false, 'value': 'asc' },
  }
  confidenceFilterValue = "";
  //vesselFilterValue = "";
  //operatorFilterValue = "";
  //dwtFilterValue = "";
  ageFilterValue = "";
  regionFilterValue="";
  vesselArrayData = [];
  operatorArrayData = [];
  tankTypeArrayData = [];
  dwtArrayData = [
    {"dwtName":"Under 10000","dwtCode":"0_9999","dwt":"All"},
    {"dwtName":"Between 10K And 20K","dwtCode":"10000_19999","dwt":"All"},
    {"dwtName":"Between 20K And 30K","dwtCode":"20000_29999","dwt":"All"},
    {"dwtName":"Between 30K And 40K","dwtCode":"30000_39999","dwt":"All"},
    {"dwtName":"Between 40k And 50K","dwtCode":"40000_49999","dwt":"All"},
    {"dwtName":"Over 50K","dwtCode":"50000_10000000","dwt":"All"}];
  ageArrayData = [
    {"key":"All","value":"0_10000"},
    {"key":"< 15","value":"0_14"},
    {"key":"15 - 20","value":"15_20"},
    {"key":"> 20","value":"21_10000"}];
  confidenceArrayData = [
    {"key":"All","value":"0_100"},
    {"key":"0 - 25","value":"0_25"},
    {"key":"26 - 50","value":"26_50"},
    {"key":"51 - 75","value":"51_75"},
    {"key":"76 - 100","value":"76_100"}];
  regionArrayData = [
  ];
  manipulatedData = [];
  userArrayCopy = [];
  mapView = false;
  showModal = false;
  trailData = [];
  metaData :any = [];
  filterData = [];
  exampleModalVar = 'exampleModal';
  lat = 20.704060;
  lng = 70.102493;
  fullMapLat=0;
  fullMapLong=0;
  markerLat;
  markerLong;
  locIcon = "assets/images/map-marker.png";
  locIconCurrent = "assets/images/map-arrow.png";
  mapDot = "assets/images/map-dot.png";
  portDot= "assets/images/port-dot.png";
  markDot= "assets/images/load-discharge-port.png";
  passingPort ="assets/images/svg/Passing-Port.svg";
  styles = this.bookingCommanStyle();
  showRegionSkel = true;
  showTableSkel = false;
  mapTrail = [];
  isDisabled = true;
  lastUpdatedDate = '-';
  heading = 0;
  dropdownList = [];
  selectedItems = [];
  selectedItemsOperator = [];
  dropdownSettings : any = {};
  vesselFilterArray = [];
  operatorFilterArray = [];
  isClearFilter = 0;
  last_position_update : any;
  vesselFilterValueTemp: any[] = [];
  operatorFilterValueTemp: any[] = [];
  dwtFilterValueTemp: any[] = [];
  tankTypeFilterValueTemp: any[] = [];
  hideAllVessalSearch =true;
  hideAllOperatorSearch =true;
  hideAllDwtSearch =true;
  hideAllTankTypeSearch =true;
  vesselFilterValue: any[] = [];
  operatorFilterValue: any[] = [];
  dwtFilterValue: any[] = [];
  tankTypeFilterValue: any[] = [];

  isConfidenceClicked = false;
  isAgeClicked = false;
  @ViewChild('ngSelectControlVessal') ngSelectControlVessal: NgSelectComponent;
  @ViewChild('ngSelectControlOperator') ngSelectControlOperator: NgSelectComponent;
  @ViewChild('ngSelectControlDwt') ngSelectControlDwt: NgSelectComponent;
  @ViewChild('ngSelectControlTankType') ngSelectControlTankType: NgSelectComponent;
  polygonArr : any = [];
  region_ids = '';
  regionFilterValueForExcel = '';
  otherRegionProbabilityData = [];
  bookingCommanStyle() {
    return [
      { 'elementType': "geometry", 'stylers': [{ 'color': "#373850" }] },
      {
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'elementType': "labels.text.fill",
        'stylers': [
          {
            'visibility': "off"
          }
        ]
      },
      {
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#16192C'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [{ 'visibility': 'off' }],
      },
    ];
  }
  bookingDetailStyle() {
    return  [
      { 'elementType': "geometry", 'stylers': [{ 'color': "#565656" }] },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#353535"
        }
      ]
    },
    {
      'featureType': "administrative.country",
      'elementType': "labels",
      'stylers': [
          { 'color': '#D2D2D2' }
      ]
  },
    {
      "featureType": "administrative.country",
      'elementType': "labels.text.fill",
      'stylers': [
          { 'visibility': 'off' }
      ]
    },
    {
      "featureType": "administrative.country",
      'elementType': "labels.text.stroke",
      'stylers': [
        {
          'color': '#D2D2D2'
        }
      ]
    },
  
      {
        "featureType": "administrative.province",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "administrative.province",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "administrative.province",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "administrative.locality",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "administrative.locality",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "poi",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "poi",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "poi",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "road",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "road",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "road",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
  
      {
        "featureType": "transit",
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        "featureType": "transit",
        'elementType': "labels.text.fill",
        'stylers': [
            { 'visibility': 'off' }
        ]
      },
      {
        "featureType": "transit",
        'elementType': "labels.text.stroke",
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      
      {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#353535'
          }
        ]
      },
      {
        'featureType': 'water',
        'elementType': 'labels.text.fill',
        'stylers': [{ 'color': '#D2D2D2' }],
      },
    ];
  }

  constructor(private appService:approvalService, private http: HttpClient,private trailService:trailService) {
    this.appService.currentApprovalStageMessage.subscribe(data => this.User = data)
    const currentYear = new Date().getFullYear();
    this.minDate = new Date();
  }
  initClusterer(event:any) {
    if (!this.googleMap?.googleMap || this.markerCluster) return
    this.markerCluster = new MarkerClusterer({
      map: this.googleMap.googleMap,
      markers: this.mapMarker,
    })
}
  loadRegionList(){
    this.appService.getRegionList().subscribe(data => {
      console.log("regionData",data)
      this.showRegionSkel = true;
      let regionData = data;//["South Africa","Northern america"];//data;
      let i = 0;
      regionData.map((d)=>{
        let regionsIds = d.Child.map((el=>{
          return el.sub_region_id;
        }))
        let sub_region_ids = regionsIds.toString();
        if(i == 0){
          this.regionFilterValue = d.regionName;
          this.region_ids = sub_region_ids;
        }
        this.regionArrayData.push({"key":d.regionName,"value":sub_region_ids})
        i++;
        this.showRegionSkel = false;
      })
      //this.regionArrayData.sort((a, b) => a.regionName.localeCompare(b.regionName))
      console.log("region",this.regionFilterValue)
      if(this.regionFilterValue){
        this.selectWeek(0,false)
      }
    },err=>{
      console.log("Error while loading region list",err)
      this.showRegionSkel = true;
    });
  }
  inprogressFilterChange(type:any){
    console.log("hello",this.confidenceFilterValue)
    console.log("vessel",this.vesselFilterValue)
    console.log("region",this.regionFilterValue)
    this.manipulatedData = this.userArrayCopy;
    console.log(this.minValue+' '+this.maxValue);
    if(type == 'confidence'){
      this.isConfidenceClicked = false;
    }
    if(type == 'age'){
      this.isAgeClicked = false;
    }
    if(type == 'region'){
      let regionSplit = this.regionFilterValue;
      let weekSplit = this.weekType;
      console.log(regionSplit)
      console.log(weekSplit)
      this.selectRegion(regionSplit);
      this.regionFilterValue = regionSplit;
      this.selectWeek(weekSplit,false)
      this.recent.push()
      //(weekSplit.length <= 3) ? this.selectWeek(weekSplit[2],true) : this.selectWeek(0,true)
    }
    /* if(type == 'vessel'){
      this.User = (this.vesselFilterValue && !this.vesselFilterValue['$ngOptionLabel']) ? this.manipulatedData.filter((el)=> el.Ship == this.vesselFilterValue) : this.userArrayCopy;
    }
    else if(type == 'operator'){
      this.User = (this.operatorFilterValue && !this.operatorFilterValue['$ngOptionLabel']) ? this.manipulatedData.filter((el)=> el.master_operator == this.operatorFilterValue) : this.userArrayCopy;
    }
    else if(type == 'dwt'){
      let rangeSplit = this.dwtFilterValue.split('_');
      let range1 = rangeSplit[0];
      let range2 = rangeSplit[1];
      this.User = (this.dwtFilterValue) ? this.manipulatedData.filter((el) => {el.DWT >= range1  && el.DWT <= range2 }) : this.userArrayCopy;
    }
    else if(type == 'age'){
      let rangeSplit = this.ageFilterValue.split('_');
      let range1 = rangeSplit[0];
      let range2 = rangeSplit[1];
      this.User = (this.ageFilterValue) ? this.manipulatedData.filter((el)=> el.age >= range1  && el.age <= range2) : this.userArrayCopy;
    }
    else if(type == 'confidence'){
      let rangeSplit = this.confidenceFilterValue.split('_');
      let range1 = parseInt(rangeSplit[0]);
      let range2 = parseInt(rangeSplit[1]);
      this.User = (this.confidenceFilterValue) ? this.manipulatedData.filter((el)=> el.probability >= range1  && el.probability <= range2) : this.userArrayCopy;
    } */
    this.User = this.manipulatedData.filter((el) => {
      let d = el;
      this.isClearFilter = 1;
      if((this.vesselFilterValue.length && this.vesselFilterValue) 
      || (this.operatorFilterValue.length && this.operatorFilterValue)
      || (this.tankTypeFilterValue.length && this.tankTypeFilterValue)
      || (this.dwtFilterValue.length && this.dwtFilterValue)
      || (this.ageFilterValue != "")
      || ((this.minValue || this.maxValue) && this.weekType != 0)
      || ((this.minAgeValue || this.maxAgeValue)))
      {
        console.log("exists");
        d = ((this.vesselFilterValue && this.vesselFilterValue.length) ? this.vesselFilterValue.includes(el.Ship) : true) &&
        ((this.operatorFilterValue && this.operatorFilterValue.length) ? this.operatorFilterValue.includes(el.master_operator) : true) &&
        ((this.tankTypeFilterValue && this.tankTypeFilterValue.length) ? this.tankTypeFilterValue.includes(el.tank_type) : true) &&
        ((this.dwtFilterValue && this.dwtFilterValue.length) ? (this.dwtFilterValueFunction(el,this.dwtFilterValue)) : true ) &&
        (((this.minValue || this.maxValue) && this.weekType !=0) ? (el.probability >= this.minValue && el.probability <= this.maxValue) : true ) &&
        (((this.minAgeValue || this.maxAgeValue)) ? (el.age >= this.minAgeValue && el.age <= this.maxAgeValue) : true )
      }
      return d
    });
  }
  dwtFilterValueFunction(el:any,dwtFilterValue){
    let first = dwtFilterValue && dwtFilterValue[0] ?  dwtFilterValue[0].split('_') : '';
    let second = dwtFilterValue && dwtFilterValue[1] ? dwtFilterValue[1].split('_') : '';
    let third = dwtFilterValue && dwtFilterValue[2] ? dwtFilterValue[2].split('_') : '';
    let fourth = dwtFilterValue && dwtFilterValue[3] ? dwtFilterValue[3].split('_') : '';
    let fifth = dwtFilterValue && dwtFilterValue[4] ? dwtFilterValue[4].split('_') : '';
    let sixth = dwtFilterValue && dwtFilterValue[5] ? dwtFilterValue[5].split('_') : '';
    return ( (el.DWT >= parseInt(first[0]) && el.DWT <= parseInt(first[1]))
    || (el.DWT >= parseInt(second[0]) && el.DWT <= parseInt(second[1]))
    || (el.DWT >= parseInt(third[0]) && el.DWT <= parseInt(third[1]))
    || (el.DWT >= parseInt(fourth[0]) && el.DWT <= parseInt(fourth[1]))
    || (el.DWT >= parseInt(fifth[0]) && el.DWT <= parseInt(fifth[1]))
    || (el.DWT >= parseInt(sixth[0]) && el.DWT <= parseInt(sixth[1]))
    );
  }
  setSortingFieldName(name:string,type:string){
    switch(name){
      case Sortingfield.probability:
        this.sortingFieldName= Sortingfield.probability;
        this.sortingFieldType =type;
        return
      case Sortingfield.eta_time:
        this.sortingFieldName= Sortingfield.eta_time;
        this.sortingFieldType =type;
        return
      default:
        this.sortingFieldName= Sortingfield.DWT;
        this.sortingFieldType =type;
        return
    }
  }
  /* field sorting functionality */
  toogleSortingOrder(fieldname: string) {
    switch (fieldname) {
      case Sortingfield.probability:
        this.sortInprogress.probability.isOpen = !this.sortInprogress.probability.isOpen;
        this.sortInprogress.DWT.isOpen = false;
        this.sortInprogress.eta_time.isOpen = false;
        return;
      case Sortingfield.DWT:
        this.sortInprogress.DWT.isOpen = !this.sortInprogress.DWT.isOpen
        this.sortInprogress.probability.isOpen = false;
        this.sortInprogress.eta_time.isOpen = false;
        return;
      case Sortingfield.eta_time:
        this.sortInprogress.eta_time.isOpen = !this.sortInprogress.eta_time.isOpen
        this.sortInprogress.probability.isOpen = false;
        this.sortInprogress.DWT.isOpen = false;
        return;
      default:
        return;
    }
  }
  onClearFilters(){
    let apiCall = false;
    this.isClearFilter = 0;
    if( (this.minValue >= 0 && this.maxValue <= 100 ) ||  (this.minAgeValue >= 0 && this.maxAgeValue <= 100 ) || this.dwtFilterValue.length || this.vesselFilterValue.length || this.operatorFilterValue.length || this.tankTypeFilterValue.length){
      apiCall = true;
    }
    this.dwtFilterValue = [];
    this.vesselFilterValue = [];
    this.operatorFilterValue = [];
    this.tankTypeFilterValue = [];
    this.ngSelectControlVessal.handleClearClick();
    this.ngSelectControlOperator.handleClearClick();
    this.ngSelectControlDwt.handleClearClick();
    this.ngSelectControlTankType.handleClearClick();
    this.minValue = 0;
    this.maxValue = 100;
    this.minAgeValue = 0;
    this.maxAgeValue = this.maxAgeValueTemp;

    (apiCall) ? this.getApiData() : '';
  }
  /* get sorting order : asc|desc */
  popUpMouseLeaveClose(val: any) {
    switch (val) {
      case Sortingfield.probability:
        this.sortInprogress.probability.isOpen = false;
        return;
      case Sortingfield.DWT:
        this.sortInprogress.DWT.isOpen = false;
        return;
      case Sortingfield.eta_time:
        this.sortInprogress.eta_time.isOpen = false;
        return;
      default:
        return;
    }
  }
  fetchSortingType(obj: any) {
    this.sortingFieldType = obj.value;
    switch (obj.col) {
      case Sortingfield.probability:
        this.sortInprogress.probability.isActive = true;
        this.sortInprogress.DWT.isActive = false;
        this.sortInprogress.eta_time.isActive = false;
        this.sortInprogress.probability.isActive ? this.sortInprogress.probability.value = obj.value : this.sortInprogress.probability.value = '';
        this.sortingFieldName = Sortingfield.probability;
    
        return;
      case Sortingfield.DWT:
        this.sortInprogress.DWT.isActive = true;
        this.sortInprogress.probability.isActive = false;
        this.sortInprogress.eta_time.isActive = false;
        this.sortInprogress.DWT.isActive ? this.sortInprogress.DWT.value = obj.value : this.sortInprogress.DWT.value = '';
        this.sortingFieldName = Sortingfield.DWT;
      
        return;
      case Sortingfield.eta_time:
        this.sortInprogress.eta_time.isActive = true;
        this.sortInprogress.probability.isActive = false;
        this.sortInprogress.DWT.isActive = false;
        this.sortInprogress.eta_time.isActive ? this.sortInprogress.eta_time.value = obj.value : this.sortInprogress.eta_time.value = '';
        this.sortingFieldName = Sortingfield.eta_time;
        return;
      default:
        return;
    }
  }
   enableRegion(){
     this.toggle = !this.toggle;
   }
   switchMapView(val:any){
    (val) ? this.mapView = true : this.mapView = false;
   }
   selectRegion(type:any){
    this.regionType = type;
   }
   selectWeek(type:any,isRecentUpdated=false,date1='',date2=''){
     this.weekType = type;
     if(date1 && date2){
        let dateFrom = new Date(date1)
        let dateTo = new Date(date2);
        if(date1 == date2){
          this.weekType = 0;
          this.range = new FormGroup({
            start: new FormControl(''),
            end: new FormControl('')
          });
        }
        let endDate = new Date(dateTo.setDate(dateTo.getDate()));
        let startDate = new Date(dateFrom.setDate(dateFrom.getDate()));
        this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+1));
        console.log((this.laycanEnd).toISOString());
        this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+1))
        console.log(this.laycanStart.toISOString());
        if(date1 != date2){
          this.range.controls.start.patchValue(new Date(startDate));
          this.range.controls.end.patchValue(endDate);
          /* this.range = new FormGroup({
            start: new FormControl(new Date(startDate)),
            end: new FormControl(new Date(endDate))
          }); */
        }
        this.laycanStart.setUTCHours(0,0,0,0);
        this.laycanEnd.setUTCHours(23,59,59,999);
     }
     else if(type == 0){
      let dateFrom = new Date();
      let dateTo = new Date();
      let dateTo1 = new Date();
      let endDate = new Date(dateTo.setDate(dateTo.getDate()));
      this.laycanEnd = new Date(dateTo1.setDate(dateTo1.getDate()));
      console.log((this.laycanEnd).toISOString());
      this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()))
      console.log(this.laycanStart.toISOString());
      //this.range.controls.start.patchValue(this.laycanStart);
      //this.range.controls.end.patchValue(endDate);
      this.range = new FormGroup({
        start: new FormControl(''),
        end: new FormControl('')
      });
      this.laycanStart.setUTCHours(0,0,0,0);
      this.laycanEnd.setUTCHours(23,59,59,999);
      const monthName = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      var month = monthName[dateFrom.getMonth()];
      var day = dateFrom.getDate();
      var year = dateFrom.getFullYear();
      let curdate = `${day} ${month} ${year}`;
      let nextRangeDate = `${endDate.getDate()} ${month} ${endDate.getFullYear()}`;
      (!isRecentUpdated) ? this.recent.push(`${this.regionFilterValue} - ${curdate} - ${nextRangeDate} `) : '';
     } else if(type == 1){
      let dateFrom = new Date();
      this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+7)); 
      let dateTo = new Date();
      this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+13));
      this.range.controls.start.patchValue(this.laycanStart);
      this.range.controls.end.patchValue(dateTo);
      this.laycanStart.setUTCHours(0,0,0,0);
      this.laycanEnd.setUTCHours(23,59,59,999);
      (!isRecentUpdated) ? this.recent.push(`${this.regionFilterValue} - Week ${type}`) : '';
     } else if(type == 2){
      let dateFrom = new Date();
      this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+14));
      let dateTo = new Date();
      this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+20));
      this.range.controls.start.patchValue(this.laycanStart);
      this.range.controls.end.patchValue(dateTo);
      this.laycanStart.setUTCHours(0,0,0,0);
      this.laycanEnd.setUTCHours(23,59,59,999);
      (!isRecentUpdated) ? this.recent.push(`${this.regionFilterValue} - Week ${type}`) : '';
     } else if(type == 3){
      let dateFrom = new Date();
      this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+21));
      let dateTo = new Date();
      this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+27));
      this.range.controls.start.patchValue(this.laycanStart);
      this.range.controls.end.patchValue(dateTo);
      this.laycanStart.setUTCHours(0,0,0,0);
      this.laycanEnd.setUTCHours(23,59,59,999);
      (!isRecentUpdated) ? this.recent.push(`${this.regionFilterValue} - Week ${type}`) : '';
     } else if(type == 4){
      let dateFrom = new Date();
      this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+28));
      let dateTo = new Date();
      this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+34));
      this.range.controls.start.patchValue(this.laycanStart);
      this.range.controls.end.patchValue(dateTo);
      this.laycanStart.setUTCHours(0,0,0,0);
      this.laycanEnd.setUTCHours(23,59,59,999);
      (!isRecentUpdated) ? this.recent.push(`${this.regionFilterValue} - Week ${type}`) : '';
     }
     this.getApiData();
     /* setTimeout(()=>{
      this.inprogressFilterChange('confidence');
     },1000) */
   }
   recentClickEvent(val:any){
    let splitValue = val.split('-');
    console.log(splitValue);
    let regionSplit = splitValue[0].split(' ');
    console.log(regionSplit);
    let weekSplit = splitValue[1].split(' ');
    console.log(regionSplit)
    console.log(weekSplit)
    this.selectRegion(splitValue[0]);
    this.regionFilterValue = splitValue[0];
    (weekSplit.length <= 3) ? this.selectWeek(weekSplit[2],true) : this.selectWeek(5,true,splitValue[1],splitValue[2])
  }
  onClickVesselDetails(imo:any = 0){
    (imo > 0) ? this.getVesselDetailsData(imo) : '';
  }
  exportExcel(){
    let regionData = this.regionArrayData.filter((el)=> el.key.trim() == this.regionFilterValue.trim())
    let body = {
      "from":this.laycanStart.toISOString(),
      "to":this.laycanEnd.toISOString(),
      "region":regionData[0].value,
      "columns":"CONFIDENCE,VESSEL,OPERATOR,DWT,AGE,TANKS,TANK TYPE,ETA,LAST PORT,NEXT PORT",
      "CONFIDENCE":`${this.minValue}_${this.maxValue}`,
      "DWT":this.dwtFilterValue,
      "VESSEL":(this.vesselFilterValue && !this.vesselFilterValue['$ngOptionLabel']) ? this.vesselFilterValue : '',
      "OPERATOR":(this.operatorFilterValue && !this.operatorFilterValue['$ngOptionLabel']) ? this.operatorFilterValue : '',
      "AGE":`${this.minAgeValue}_${this.maxAgeValue}`,
      "TANK_TYPE":this.tankTypeFilterValue.join('_')
    }
    this.appService.postExcelExport(body)
  }
  getVesselDetailsData(imo:any){
    let queryParams = imo;
    this.metaData = [];
    this.polygonArr = [];
    this.trailService.fetchData(queryParams).subscribe(data => {
      setTimeout(() => {
        this.trailData = data.data;
        this.metaData = data.metaData;
        // port data arrival & departure
        for(let i=0; i<this.trailData?.length; i++){
          this.trailData[i]["arrivalTime"] = this.metaData['port_timings'][0][i].arrival_time;
          this.trailData[i]["departureTime"] = this.metaData['port_timings'][0][i].departure_time;
          this.trailData[i]["stop_port_UNlocode"] = this.metaData['port_timings'][0][i].stop_port_UNlocode;
          this.trailData[i]["stop_port_name"] = this.metaData['port_timings'][0][i].port_name;
          this.trailData[i]["draught"] = this.metaData['port_timings'][0][i].draft_at_arrival_calculated;
          this.trailData[i]["Latitude"] = this.metaData['port_timings'][0][i].latitude;
          this.trailData[i]["Longitude"] = this.metaData['port_timings'][0][i].longitude;
        }
        // calling map route api here
        this.trailService.fetchMapData(queryParams).subscribe(data => {
          /* this.mapTrail = data.data.filter((d)=>{
            let lengthTrail = this.trailData.length;
            let firstPortArrivalDate = this.trailData[0]['arrivalTime'];
            let lastPortDepartureDate = this.trailData[lengthTrail-1]['departureTime'];
            return d.timestamp >= firstPortArrivalDate && d.timestamp <= lastPortDepartureDate
          }); */
          this.mapTrail = data.data;
          this.mapTrail.sort((a,b)=>{
            return a.timestamp.localeCompare(b.timestamp)
          })
          this.last_position_update = this.mapTrail[this.mapTrail.length - 1]
          this.last_position_update = this.last_position_update.timestamp;
          /* console.log("last position update",this.last_position_update);
          let dd = this.last_position_update.timestamp;
          let day = new Date(dd).getDate();
          let month = new Date(dd).getMonth() + 1;
          let year = new Date(dd).getFullYear();
          let split = dd.split(" ")[1].split(":");
          let dateSplit = dd.split(" ")[0].split("-");
          let hrs = split[0];
          let mins = split[1];
          this.last_position_update = `${day}/${dateSplit[1]}/${year} ${hrs}:${mins}`; */
          setTimeout(()=>{
            this.polygonArr = this.mapTrail.map((el)=> ({lat:parseFloat(el.latitude),lng:parseFloat(el.longitude)}))
          console.log("poly",this.polygonArr)
          console.log("map trail",this.mapTrail)
          let length = Math.round(this.mapTrail.length/2);
          this.optionsMap.center.lat = (this.mapTrail && this.mapTrail[length].latitude) ? this.mapTrail[length].latitude : this.lat ;
          this.optionsMap.center.lng = (this.mapTrail && this.mapTrail[length].longitude) ? this.mapTrail[length].longitude : this.lng ;
          },100)

        },err=>{
          console.log("trail map api error",err)
          this.mapTrail = [];
        })
      }, 1000);
      
      
    let filter = this.User.filter((m)=> m.imo == imo)
    this.filterData = filter[0];
    this.heading = this.filterData['heading'] + 110;
    this.showModal = true;
    this.exampleModalVar = 'exampleModal';
    console.log(this.trailData)

    // other region probability api hit
    let otherQueryParams = {"from":this.laycanStart.toISOString(),"to":this.laycanEnd.toISOString(),"imo":imo};
    this.trailService.fetchOtherRegionProbabilityData(otherQueryParams).subscribe(data => {
      console.log("other region data",data)
      let result = data.data;

      this.otherRegionProbabilityData = result.filter((el)=>el.region != this.filterData['region']);
    },err=>{
      console.log("other region probability api error",err)
      this.otherRegionProbabilityData = []
    })
    
  },err=>{
    console.log("trail api error",err)
    this.showModal = false;
  })
  
  }
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
    const monthName = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    this.weekType = '5';
    if(this.User){
      this.User = this.portData
    }
    console.log(new Date(dateRangeStart.value),new Date(dateRangeEnd.value))
    let endD = (this.range.value.end)
    let start = (this.range.value.start);
    let someDate = new Date(start.setDate(start.getDate()));
    let someDate1 = new Date(endD.setDate(endD.getDate()));
    let range1 = `${someDate.getDate()} ${monthName[someDate.getMonth()]} ${someDate.getFullYear()}`;
    let range2 = `${someDate1.getDate()} ${monthName[someDate1.getMonth()]} ${someDate1.getFullYear()}`;
    let week = `${this.regionFilterValue} - `+range1 + " - " +range2;
    
    if(dateRangeEnd.value){
      //this.recent.push({'key':regionData[0],'value':`${regionData[1]} - ${range1} - ${range2} `})
      this.recent.push(week);
    }
    this.range.controls.start.patchValue(someDate);
    this.range.controls.end.patchValue(someDate1);
    let temp = start;
    let temp2 = endD;
    temp = new Date(temp.setDate(temp.getDate()+1));
    temp2 = new Date(temp2.setDate(temp2.getDate()+1));
    this.laycanStart = temp;
    this.laycanEnd = temp2;
    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);
    this.getApiData();
   /*  this.toggle1 = true;
      this.toggle2 = true;
      this.toggle3 = true;
      this.toggle4 = true;
      this.toggle5 = true; */ 
  }

  setChecked(){
    this.isChecked=!this.isChecked;
  }

  getApiData(value=''){
    console.log(this.laycanStart.toISOString(), this.laycanEnd.toISOString());
    let currentYear = new Date().getFullYear();
    let regionData = this.regionArrayData.filter((el)=> el.key.trim() == this.regionFilterValue.trim())
    let queryParams = {"from":this.laycanStart.toISOString(),"to":this.laycanEnd.toISOString(),"region":regionData[0].value};
    this.showTableSkel = true;
    const monthName = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    this.appService.fetchData(queryParams)
  .subscribe(data => {
    if(data.data){
      this.isDisabled = false;
      data.updated_at = data.data.slice(-1).pop();
      let updatedDate = data.updated_at.updated_at.split('T');
      let day = updatedDate[0].split('-');
      this.lastUpdatedDate = day[2]+' '+ monthName[parseInt(day[1])-1]+' '+day[0];//data.updated_at;
      data = data.data;
      data = data.filter((el)=>el.imo && el.imo > 0);
      this.User = data.filter(m => m.probability = m.probability*100);
      data.forEach(element => {
        element["age"] = Math.abs(element.Built - currentYear);
        element["stop_port_name"] = (element.stop_port_name && element.stop_port_name != null) ? element.stop_port_name : '';
        element["stop_port_UNlocode"] = (element.stop_port_UNlocode && element.stop_port_UNlocode != null) ? element.stop_port_UNlocode : '';
      });
      //data.sort((a, b) => a.Ship.localeCompare(b.Ship));
      console.log("data",data)
      // need to set filter option here
      let vessels = Array.from(new Set(data.map((el)=> el.Ship)));
      let vesselsObj = vessels.map((el,index)=>{
        return {"vesselCode" : index+1,"vesselName":el,"vessel":"All"}
      });
      console.log(vesselsObj);
      let operators = Array.from(new Set(data.map((el)=> el.master_operator)));
      let operatorObj = operators.map((el,index)=>{
        return {"operatorCode" : index+1,"operatorName":el,"operator":"All"}
      });
      let tankType = Array.from(new Set(data.map((el)=> el.tank_type)));
      let tankTypeObj = tankType.map((el,index)=>{
        return {"tankTypeCode" : index+1,"tankTypeName":el,"tankType":"All"}
      });
      let dwt = Array.from(new Set(data.map((el)=> el.DWT)));
      this.vesselArrayData = vesselsObj;
      this.operatorArrayData = operatorObj;
      this.tankTypeArrayData = tankTypeObj;
      this.maxAgeValue = Math.max(...data.map((o:any) => o.age), 0);
      this.maxAgeValueTemp = this.maxAgeValue;
      this.optionsAge = {
        floor: 0,
        ceil: this.maxAgeValue
      }
      //this.dwtArrayData = dwt;
      this.userArrayCopy = data;
      this.showTableSkel = false;
      console.log("new user data",data)
      let length = Math.round(data.length/2);
      this.fullMapLat = (data && data[length].current_lat) ? data[length].current_lat : this.lat ;
      this.fullMapLong = (data && data[length].current_lon) ? data[length].current_lon : this.lng ;
      if( (this.minValue > 0 && this.maxValue < 100) || (this.minAgeValue > 0 && this.maxAgeValue < 100)
      || this.vesselFilterValue.length || this.dwtFilterValue.length || this.operatorFilterValue.length || this.tankTypeFilterValue.length){
        this.inprogressFilterChange('')
      } else {
        this.User = data;
      }
    } else {
      this.User = [];
      this.showTableSkel = false;
      this.isDisabled = true;
    }
    // set data in service which is to be shared
    //this.appService.updateApprovalMessage(data);
  })
  console.log("users data",this.User)
  }

  onclick(){
    // console.log(this.portData)
    this.toggle1 = !this.toggle1;
    this.User = this.portData;
    if(this.toggle1 == false){
      this.toggle2 = true;
      this.toggle3 = true;
      this.toggle4 = true;
      this.toggle5 = true;
    }
    
    let dateFrom = new Date();
    let dateTo = new Date();
    let dateTo1 = new Date();
    this.laycanEnd = new Date(dateTo1.setDate(dateTo1.getDate()));
    // tempDate.setDate(tempDate.getDate() - 2);
    // console.log((dateFrom.setDate(dateFrom.getDate()-1)).getUTCDate());
    console.log((this.laycanEnd).toISOString());
    
    // console.log(Date.UTC(tempDate1));
    this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()))
    console.log(this.laycanStart.toISOString());
    this.range.controls.start.patchValue(this.laycanStart);
    this.range.controls.end.patchValue(dateTo);

    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);
    
    // let selectedMembers = this.User.filter(
    //   m => (m.eta_time) <= (this.laycanEnd.toISOString()) && (m.eta_time) >=(this.laycanStart.toISOString())
    //   );
    // let selectedMembers1 = selectedMembers.filter(
    //   m => m.position_updated_within_7_days=="Yes"
    // )
    this.getApiData();
    console.log(this.User)
    // console.log(selectedMembers);
    // this.User=selectedMembers1;
    // this.mapRangeChange(selectedMembers1);
    
  }

  setWeek(){
    this.toggle2 = !this.toggle2;
    if(this.toggle2 == false){
      this.toggle1 = true;
      this.toggle3 = true;
      this.toggle4 = true;
      this.toggle5 = true;
    }
    let week = "Houston - Next 1 Week";
    this.recent.push(week);

    let dateFrom = new Date();
    this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+7)); 
    let dateTo = new Date();
    this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+13));

    this.range.controls.start.patchValue(this.laycanStart);
    this.range.controls.end.patchValue(dateTo);

    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);
    // let selectedMembers = this.User.filter(
    //   m => m.eta_time <= this.laycanEnd.toISOString() && m.eta_time >= this.laycanStart.toISOString()
    //   );

    // this.User=selectedMembers;
    // this.mapRangeChange(selectedMembers);
    this.getApiData();
  }

  setWeek2(){
    this.toggle3 = !this.toggle3;
    if(this.toggle3 == false){
      this.toggle1 = true;
      this.toggle2 = true;
      this.toggle4 = true;
      this.toggle5 = true;
    }
    let week = "Houston - Next 2 Week";
    this.recent.push(week);

    let dateFrom = new Date();
    this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+14));
    let dateTo = new Date();
    this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+20));

    this.range.controls.start.patchValue(this.laycanStart);
    this.range.controls.end.patchValue(dateTo);

    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);

    this.getApiData();
  }

  setWeek3(){
    this.toggle4 = !this.toggle4;
    if(this.toggle4 == false){
      this.toggle1 = true;
      this.toggle2 = true;
      this.toggle3 = true;
      this.toggle5 = true;
    }
    let week = "Houston - Next 3 Week";
    this.recent.push(week);

    this.User = this.portData;

    let dateFrom = new Date();
    this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+21));
    let dateTo = new Date();
    this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+27));

    this.range.controls.start.patchValue(this.laycanStart);
    this.range.controls.end.patchValue(dateTo);

    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);

    this.getApiData();
  }

  setWeek4(){
    this.toggle5 = !this.toggle5;
    if(this.toggle5 == false){
      this.toggle1 = true;
      this.toggle2 = true;
      this.toggle3 = true;
      this.toggle4 = true;
    }
    let week = "Houston - Next 4 Week";
    this.recent.push(week);

    this.User = this.portData;

    let dateFrom = new Date();
    this.laycanStart = new Date(dateFrom.setDate(dateFrom.getDate()+28));
    let dateTo = new Date();
    this.laycanEnd = new Date(dateTo.setDate(dateTo.getDate()+34));

    this.range.controls.start.patchValue(this.laycanStart);
    this.range.controls.end.patchValue(dateTo);

    this.laycanStart.setUTCHours(0,0,0,0);
    this.laycanEnd.setUTCHours(23,59,59,999);

    this.getApiData();
  }

  clearRecent(){
    this.recent = [];
  }

  mapRangeChange(val) {
    
    this.appService.updateApprovalMessage(val);
    //  this.appService.updateApprovalMessage(val)
  }
  onItemSelect(item: any,type:any) {
    console.log(item);
    if(type == 'vs'){
      this.vesselFilterArray.push(item)
    } if(type == 'op'){
      this.operatorFilterArray.push(item)
    }
    console.log("ffff",this.vesselFilterArray);
    console.log("operator",this.operatorFilterArray);
    this.inprogressFilterChange('')
  }
  onSelectAll(items: any,type:any) {
    console.log(items);
    if(type == 'vs'){
      this.vesselFilterArray = items;
    } else if(type == 'op'){
      this.operatorFilterArray = items;
    }
    console.log("ffff",this.vesselFilterArray);
    this.inprogressFilterChange('')
  }
  onDeSelectAll(items: any,type:any) {
    console.log(items);
    if(type == 'vs'){
      this.vesselFilterArray = items;
    } else if(type == 'op'){
      this.operatorFilterArray = items;
    }
    console.log("ffff",this.vesselFilterArray);
    this.inprogressFilterChange('')
  }
  onDeSelect(item: any,type:any) {
    console.log(item);
    if(type == 'vs'){
      this.vesselFilterArray = this.vesselFilterArray.filter(value => item !== value)
    } else if(type == 'op'){
      this.operatorFilterArray = this.operatorFilterArray.filter(value => item !== value)
    }
    console.log("ffff",this.vesselFilterArray);
    this.inprogressFilterChange('')
  }

  ngOnInit(): void {
    this.getScreenWidth = window.innerWidth;
    console.log(this.getScreenWidth);
    this.confidenceFilterValue = "";
    this.loadRegionList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      clearSearchFilter: true,
      noDataAvailablePlaceholderText : 'No Record Found'
    };
    document.addEventListener("click",(e:any)=>{
      const id = document.getElementById("confidenceId");
      const id2 = document.getElementById("confidenceId2");
      const isClickInside = id.contains(e.target);
      if (!isClickInside && !id2.contains(e.target)) {
        this.isConfidenceClicked = false;
      }
      const ageid = document.getElementById("ageId");
      const ageid2 = document.getElementById("ageId2");
      const isClickInsideAge = ageid.contains(e.target);
      if (!isClickInsideAge && !ageid2.contains(e.target)) {
        this.isAgeClicked = false;
      }
      e.stopPropagation();
    });
    this.styles = this.bookingDetailStyle();
    this.optionsMap ={
      zoom: 3,
      minZoom: 2,
      styles: this.styles,
      streetViewControl:false,
       center:{lat:this.lat,lng:this.lng},
      }
    this.optionsMap1 ={
      strokeColor:'#008ECF',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      fillOpacity: 1.0,
      geodesic: true,
      icons: [{
          fixedRotation:false,
          //icon: {path:'M 0,0 5,15 -5,15 0,0 z'},
          offset: '90%',
          repeat:'200px'
      }]
    }
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
  }

  ngOnDestroy() {
    console.log("destroy");
    
    this.User.unsubscribe()
}
/* -----------serach Functinality -----------*/
customSearch(type: string,event : Event,mobile =false) {  
  switch (type) {
    case 'vessel':
      (event.target as HTMLInputElement).value =="" ?this.hideAllVessalSearch = true : this.hideAllVessalSearch = false;
       return this.ngSelectControlVessal.filter((event.target as HTMLInputElement).value);
    case 'operator':
    (event.target as HTMLInputElement).value =="" ?this.hideAllOperatorSearch = true : this.hideAllOperatorSearch = false;
      return this.ngSelectControlOperator.filter((event.target as HTMLInputElement).value);
    case 'dwt':
      (event.target as HTMLInputElement).value =="" ?this.hideAllDwtSearch = true : this.hideAllDwtSearch = false;
        return this.ngSelectControlDwt.filter((event.target as HTMLInputElement).value);
    case 'tankType':
      (event.target as HTMLInputElement).value =="" ?this.hideAllTankTypeSearch = true : this.hideAllTankTypeSearch = false;
        return this.ngSelectControlTankType.filter((event.target as HTMLInputElement).value);
  
  }
}
submitFilterMultiple(type :string){
  switch (type) {
    case 'vessel':
         if(this.vesselFilterValueTemp.includes('All')){
        this.vesselFilterValueTemp = this.vesselArrayData.map(it=> it.vesselName);
        this.vesselFilterValue =this.vesselFilterValueTemp;
        this.ngSelectControlVessal.close();
        this.inprogressFilterChange('');
        }else{
          this.vesselFilterValue =this.vesselFilterValueTemp;
          console.log(this.vesselFilterValue)
          this.ngSelectControlVessal.close();
          this.inprogressFilterChange('');
        }
      return;
      case 'operator':
        if(this.operatorFilterValueTemp.includes('All')){
       this.operatorFilterValueTemp = this.operatorArrayData.map(it=> it.operatorName);
       this.operatorFilterValue =this.operatorFilterValueTemp;
       this.ngSelectControlOperator.close();
       this.inprogressFilterChange('');
       }else{
         this.operatorFilterValue =this.operatorFilterValueTemp;
         console.log(this.operatorFilterValue)
         this.ngSelectControlOperator.close();
         this.inprogressFilterChange('');
       }
     return;
    case 'dwt':
    if(this.dwtFilterValueTemp.includes('All')){
    this.dwtFilterValueTemp = this.dwtArrayData.map(it=> it.dwtCode);
    this.dwtFilterValue =this.dwtFilterValueTemp;
    this.ngSelectControlDwt.close();
    this.inprogressFilterChange('');
    }else{
      this.dwtFilterValue =this.dwtFilterValueTemp;
      console.log(this.dwtFilterValue)
      this.ngSelectControlDwt.close();
      this.inprogressFilterChange('');
    }
    return;
    case 'tankType':
    if(this.tankTypeFilterValueTemp.includes('All')){
    this.tankTypeFilterValueTemp = this.tankTypeArrayData.map(it=> it.tankTypeName);
    this.tankTypeFilterValue =this.tankTypeFilterValueTemp;
    this.ngSelectControlTankType.close();
    this.inprogressFilterChange('');
    }else{
      this.tankTypeFilterValue =this.tankTypeFilterValueTemp;
      console.log(this.tankTypeFilterValue)
      this.ngSelectControlTankType.close();
      this.inprogressFilterChange('');
    }
    return;

    default:
    return;
  }
}

resetFilterMultiple(type :string){
  switch (type) {
    case 'vessel':
      this.ngSelectControlVessal.handleClearClick();
      this.vesselFilterValueTemp=[];
      this.vesselFilterValue =this.vesselFilterValueTemp;
      this.inprogressFilterChange('');
      return;
    case 'operator':
      this.ngSelectControlOperator.handleClearClick();
      this.operatorFilterValueTemp=[];
      this.operatorFilterValue =this.operatorFilterValueTemp;
      this.inprogressFilterChange('');
      return;
    case 'dwt':
      this.ngSelectControlDwt.handleClearClick();
      this.dwtFilterValueTemp=[];
      this.dwtFilterValue =this.dwtFilterValueTemp;
      this.inprogressFilterChange('');
      return;
    case 'tankType':
      this.ngSelectControlTankType.handleClearClick();
      this.tankTypeFilterValueTemp=[];
      this.tankTypeFilterValue =this.tankTypeFilterValueTemp;
      this.inprogressFilterChange('');
      return;

    default:
      return;
  }
}
toggleSlider(value:any,event){
  if(value=="confidence"){
    this.isConfidenceClicked = !this.isConfidenceClicked;
    this.isAgeClicked = false
  } else if(value=='age'){
    this.isAgeClicked = !this.isAgeClicked;
    this.isConfidenceClicked = false;
  }
  
}
resetSlider(type:any){
  if(type == 'confidence'){
    this.minValue = 0;
    this.maxValue = 100;
  }
  else if(type == 'age'){
    this.minAgeValue = 0;
    this.maxAgeValue = this.maxAgeValueTemp;
  }
  this.inprogressFilterChange('');
}
openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow) {
  infoWindow.open(marker);
}

}
